@if (initialized && formId) {
    <div class="p-3">
        <uf-form-renderer
            [formId]="formId"
            (onSave)="handleSave($event)"
            (onCancel)="handleCancel()">
        </uf-form-renderer>
    </div>
}
